module.exports = __webpack_public_path__ + "95b4bb251bd31176655c8cdc9b9d8ce3.svg";